import { Text, Input } from '@revenuemarket/cds';
import { Form } from 'antd';

interface Props {
  disabled?: boolean;
  passwordErrorExist?: boolean;
  setPasswordErrorExist?: (value: boolean) => void;
}

const CertificatePassword = ({ disabled, passwordErrorExist, setPasswordErrorExist }: Props) => {
  return (
    <Form.Item name="password" label={<Text textStyle="16_400">공동인증서 비밀번호</Text>}>
      <Input
        type="password"
        placeholder={
          disabled ? '공동인증서를 선택해주세요' : '선택한 공동인증서의 비밀번호를 입력해주세요'
        }
        additionalText={passwordErrorExist ? '비밀번호가 일치하지 않습니다.' : ''}
        inputStatus={passwordErrorExist ? 'error' : undefined}
        inputSize="xlarge"
        disabled={disabled}
        onChange={(e) => {
          if (setPasswordErrorExist) {
            setPasswordErrorExist(false);
          }
        }}
      />
    </Form.Item>
  );
};

export default CertificatePassword;
